var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFragment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H7V7H0V0Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 0H15V1.46032L11 0Z",
    fill: "current"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15 4.27666L11 2.81633V0H8V7H11.0001V5.63271L15 4.49483V4.27666Z",
    fill: "current"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0001 8H8V15H13.5155L11.0001 14.0817V11.2653L15 10.1275V9.90931L11.0001 8.44904V8Z",
    fill: "current"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4438 16H8V23H15V21.1746L11.0001 19.7144V16.898L14.4438 16Z",
    fill: "current"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16 21.5397V23H19.9999L16 21.5397Z",
    fill: "current"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9999 23H23V16H20L20.0001 17.3674L16 18.4105V18.7234L20 20.1837L19.9999 23Z",
    fill: "current"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M20 15H23V8H17.4844L20 8.91838L20.0001 11.7347L16 12.7778V13.0907L20 14.551L20 15Z",
    fill: "current"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5568 7H23V0H16V1.8254L20 3.28571L20.0001 6.1021L16.5568 7Z",
    fill: "current"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M0 8H7V15H0V8Z",
    fill: "current"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M7 16H0V23H7V16Z",
    fill: "current"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M23 1H24V24H23V1Z",
    fill: "current"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M1 23H23V24H1V23Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFragment);
export default __webpack_public_path__ + "static/media/Fragment.63e1caa04e9fdcc24e1723a0e0dea5e0.svg";
export { ForwardRef as ReactComponent };